
<div class="container">


  <h2 class="content-heading">
      <button class="btn btn-sm btn-outline-secondary float-right" (click)="add()">
        <i class="fa fa-plus mr-5"></i>Add
      </button>
        Liturgy Type \ Lectionary Item Display Order
  </h2>


<div class="block">

  <!--
  <div class="block-header block-header-default">
      <h3 class="block-title"></h3>
  </div>
-->

  <div class="block-content">
      <div class="table-responsive ">
          <table class="table table-striped table-vcenter table-sm" *ngIf="isLoading==false">
              <thead>
                  <tr>
                    <th>Liturgy Type</th>
                    <th>Lectionary Item Type</th>
                    <th>Sub Type</th>
                    <th class="text-right">Display Order</th>
                    <th></th>
                    <th class="text-center" style="width: 100px;">
                        <!-- Actions -->
                    </th>
                  </tr>
              </thead>
              <tbody>


                <tr *ngFor="let obj of data">
                  <td class="font-w600">{{obj.LiturgyType?.Localized[0].Name}} </td>
                  <td class="font-w600">{{obj.LectionaryItemType?.Localized[0].Name}}</td>
                  <td class="font-w600">{{obj.LectionaryItemTypeSubType?.Localized[0].Name}}</td>
                  <td class="font-w600 text-right">{{obj.DisplayOrder}}</td>
                  <td class="font-w600"></td>
                  <td class="text-center">
                      <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                              <i class="fa fa-pencil"></i>
                          </button> 
                         <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(obj)">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                  </td>
                </tr>

              </tbody>
          </table>

          <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

        </div>


  </div>

</div>

</div>

